import { useNavigate } from 'react-router-dom';

const BlogCTA = () => {
  const navigate = useNavigate();

  const handleGetAssessment = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 sm:p-12 text-center">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-5">
            <i className="ri-alarm-warning-line text-3xl text-red-400"></i>
          </div>
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
            Already Dealing With Water Damage?
          </h3>
          <p className="text-gray-300 text-sm sm:text-base max-w-lg mx-auto mb-8">
            Don&apos;t wait — water damage gets worse every hour. Our IICRC-certified team is available 24/7 for emergency response across Davis County, Utah.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <a
              href="tel:3853406632"
              className="w-full sm:w-auto text-center bg-sky-500 text-white px-8 py-3.5 rounded-lg text-sm font-semibold transition-all duration-200 hover:brightness-90 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Now: (385) 340-6632
            </a>
            <button
              onClick={handleGetAssessment}
              className="w-full sm:w-auto text-center border border-white/30 text-white px-8 py-3.5 rounded-lg text-sm font-semibold transition-all duration-200 hover:brightness-90 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Get Free Assessment
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogCTA;
